
import React from 'react';
import { Card, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

interface AppraisalMetricsCardsProps {
  totalAppraisals: number;
  submittedAppraisals: number;
  managerRatingDoneAppraisals: number;
  completedAppraisals: number;
  isVisible: boolean;
}

export const AppraisalMetricsCards: React.FC<AppraisalMetricsCardsProps> = ({
  totalAppraisals,
  submittedAppraisals,
  managerRatingDoneAppraisals,
  completedAppraisals,
  isVisible
}) => {
  if (!isVisible) return null;

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
      <Card className="bg-gradient-to-br from-blue-500/20 to-blue-600/30 border-blue-500/30 hover:shadow-lg hover:shadow-blue-500/25 transition-all duration-300">
        <CardHeader className="py-3">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <div className="text-2xl font-bold text-blue-400">{totalAppraisals}</div>
              <span className="text-white font-bold text-[12px]">Total Appraisals</span>
            </div>
            <Badge className="bg-blue-500/20 text-blue-300 border-blue-500/50">
              Team Members
            </Badge>
          </div>
        </CardHeader>
      </Card>

      <Card className="bg-gradient-to-br from-purple-500/20 to-purple-600/30 border-purple-500/30 hover:shadow-lg hover:shadow-purple-500/25 transition-all duration-300">
        <CardHeader className="py-3">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <div className="text-2xl font-bold text-purple-400">{submittedAppraisals}</div>
              <span className="text-white font-bold text-[12px]">Self Rating Done</span>
            </div>
            <Badge className="bg-purple-500/20 text-purple-300 border-purple-500/50">
              All goals completed
            </Badge>
          </div>
        </CardHeader>
      </Card>

      <Card className="bg-gradient-to-br from-orange-500/20 to-orange-600/30 border-orange-500/30 hover:shadow-lg hover:shadow-orange-500/25 transition-all duration-300">
        <CardHeader className="py-3">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <div className="text-2xl font-bold text-orange-400">{managerRatingDoneAppraisals}</div>
              <span className="text-white font-bold text-[12px]">Manager Rating Done</span>
            </div>
            <Badge className="bg-orange-500/20 text-orange-300 border-orange-500/50">
              All goals completed
            </Badge>
          </div>
        </CardHeader>
      </Card>

      <Card className="bg-gradient-to-br from-green-500/20 to-green-600/30 border-green-500/30 hover:shadow-lg hover:shadow-green-500/25 transition-all duration-300">
        <CardHeader className="py-3">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <div className="text-2xl font-bold text-green-400">{completedAppraisals}</div>
              <span className="text-white font-bold text-[12px]">Final Rating Done</span>
            </div>
            <Badge className="bg-green-500/20 text-green-300 border-green-500/50">
              Finalized
            </Badge>
          </div>
        </CardHeader>
      </Card>
    </div>
  );
};
